const LineChartIcon = ({active}) => {
  const strokeColor = active ? "#0C0C0F" : "#828282";
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.91669 11.6664C3.17299 9.8252 4.47793 5.11218 6.08312 5.11218C7.19257 5.11218 7.47988 7.37026 8.5671 7.37026C10.4376 7.37026 10.1665 2.33301 12.25 2.33301"
        stroke={strokeColor}
        stroke-width="1.17434"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LineChartIcon;
